import React from 'react';

import MuiPaper, { PaperProps as MuiPaperProps } from '@mui/material/Paper';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const Paper = withCoreProps<PaperProps>(
  ({ children, className, ...props }: React.PropsWithChildren<PaperProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiPaper {...props} className={clsxClass}>
        {children}
      </MuiPaper>
    );
  },
);

export interface PaperProps extends MuiPaperProps, CoreProps {}
